import { type FC, type ReactNode } from 'react';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ThemeProvider } from './ThemeProvider';
import { ScaleProvider } from './ScaleProvider';
import { AuthProvider } from '../contexts/AuthContext';
import { UploadQueueProvider } from './UploadQueueProvider';
import { ScaledTheme } from '@/components/ScaledTheme.tsx';
import { ThemeInitializer } from '@/components/ThemeInitializer';
// TODO:  Slavik: Need to Improve imports (tsconfig)
import { Toaster } from '@/components/ui';
import { persistor, store } from '@/store';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

interface AppProvidersProps {
  children: ReactNode;
}

export const AppProviders: FC<AppProvidersProps> = ({ children }) => {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <QueryClientProvider client={queryClient}>
          <ScaleProvider>
            <ThemeProvider>
              <ThemeInitializer />
              <ScaledTheme>
                <AuthProvider>
                  <UploadQueueProvider>{children}</UploadQueueProvider>
                </AuthProvider>
              </ScaledTheme>
              <Toaster />
            </ThemeProvider>
          </ScaleProvider>
        </QueryClientProvider>
      </PersistGate>
    </Provider>
  );
};
